// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Jeagt","default_logo":"styles_default_logo__asNi2"};